import { render, staticRenderFns } from "./DisplayData.vue?vue&type=template&id=4867d951"
import script from "./DisplayData.vue?vue&type=script&lang=ts"
export * from "./DisplayData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports